// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperFinderUpsell-cls1_Y6t","cls2":"PaperFinderUpsell-cls2_GI- PaperFinderUpsell-cls1_Y6t"};